import * as classNames from 'classnames';
import * as React from 'react';
import withStyles, { StyledComponentProps } from 'react-jss';
import { Link } from 'react-router-dom';
import Responsive from 'src/_context/Responsive';
import responsive from 'src/constants/responsive';
import spacing from 'src/constants/spacing';
import stylesheet, { directions } from 'src/constants/stylesheet';
import { Language } from 'src/utils/Languages';
import Close from './Close';
import Image from './Image';

export type ProjectListProps = ProjectsDto;

const styles = {
    container: {},
    containerInner: {
        [responsive.MobileBig]: {
            display: 'flex',
            flexWrap: 'wrap',
            padding: `0 ${spacing.Gutter.Mobile / 2}px`
        },
    },
    projectItem: {
        ...stylesheet.MarginGutter(1, directions.bottom),
        [responsive.Mobile]: {
            paddingBottom: spacing.Gutter.Mobile
        },
        [responsive.MobileBig]: {
            width: '50%'
        },
        [responsive.Tablet]: {
            paddingBottom: spacing.Gutter.Tablet
        },
        [responsive.Laptop]: {
            paddingBottom: spacing.Gutter.Laptop
        },
        [responsive.Desktop]: {
            paddingBottom: spacing.Gutter.Desktop
        }
    },
    projectItemInner: {
        display: 'flex',
        position: 'relative',
        [responsive.Mobile]: {
            flexDirection: 'column-reverse',
        },
        [responsive.Tablet]: {
            flexDirection: 'column-reverse',
        }
    },
    fadeOut: {
        opacity: .3
    },
    projectText: {
        [responsive.Mobile]: {
            width: '100%',
            padding: `0 ${spacing.Gutter.Mobile}px`
        },
        [responsive.MobileBig]: {
            padding: `0 ${spacing.Gutter.Mobile / 2}px`
        },
        [responsive.Tablet]: {
            // width: '100%',
            padding: `0 ${spacing.Gutter.Tablet / 2}px`
        },
        [responsive.Laptop]: {
            width: '50%',
            padding: `0 ${spacing.Gutter.Laptop / 2}px`
        },
        [responsive.Desktop]: {
            width: '50%',
            padding: `0 ${spacing.Gutter.Desktop / 2}px`
        }
    },
    projectTitle: {
        color: 'black'
    },
    projectSubtitle: {
        '$projectItem:hover &': {
            color: 'black'
        }
    },
    projectImage: {
        [responsive.Mobile]: {
            width: '100%',
            padding: `0 ${spacing.Gutter.Mobile}px ${spacing.Gutter.Mobile / 2}px ${spacing.Gutter.Mobile}px`
        },
        [responsive.MobileBig]: {
            padding: `0 ${spacing.Gutter.Mobile / 2}px ${spacing.Gutter.Mobile / 2}px ${spacing.Gutter.Mobile / 2}px`
        },
        [responsive.Tablet]: {
            // width: '100%',
            padding: `0 ${spacing.Gutter.Tablet / 2}px ${spacing.Gutter.Tablet / 2}px ${spacing.Gutter.Tablet / 2}px`
        },
        [responsive.Laptop]: {
            width: '50%',
            padding: `0 ${spacing.Gutter.Laptop / 2}px`
        },
        [responsive.Desktop]: {
            width: '50%',
            padding: `0 ${spacing.Gutter.Desktop / 2}px`
        }
    },
    projectImageInner: {
        position: 'relative',
        height: 0,
        paddingBottom: '67%'
    },
    figure: {
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        transition: 'opacity .4s ease'
    },
    image: {
        width: '100%',
        height: '100%',
        objectFit: 'cover'
    },
    link: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 1
    },
    linkDouble: {
        position: 'absolute',
        top: 0,
        zIndex: 1,
        [responsive.Mobile]: {
            height: 0,
            left: 0,
            right: 0,
            paddingBottom: '67%'
        },
        [responsive.MobileBig]: {
            height: 0,
            left: 0,
            right: 0,
            paddingBottom: '67%'
        },
        [responsive.Tablet]: {
            height: 0,
            left: 0,
            right: 0,
            paddingBottom: '67%'
        },
        [responsive.Laptop]: {
            height: '100%',
            left: '50%',
            right: 0,
        },
        [responsive.Desktop]: {
            height: '100%',
            left: '50%',
            right: 0,
        }
    },
    header: {
        position: 'sticky',
        top: 0,
        zIndex: 1,
        color: 'black',
        ...stylesheet.PaddingGutter(1, directions.all)
    }
};

type Props =
    ProjectListProps &
    StyledComponentProps<keyof typeof styles>;

type State = {
    itemHovered?: number;
}

class ProjectList extends React.Component<Props, State> {

    private scrollContainer = document.getElementById("scrollContainer");
    constructor(props: Props) {
        super(props);

        this._HandleMouseEnter = this._HandleMouseEnter.bind(this);
        this._HandleMouseLeave = this._HandleMouseLeave.bind(this);

        this.state = {}
    }
    componentDidMount() {

        if (this.scrollContainer && this.scrollContainer.scrollTop > 0) {
            this.scrollContainer.scrollTop = 0;
        }
    }

    componentDidUpdate(prevProps: Props, prevState: State) {

        if (prevState !== this.state) { return; }

        if (this.scrollContainer && this.scrollContainer.scrollTop > 0) {
            this.scrollContainer.scrollTop = 0;
        }
    }

    render() {
        const { classes, Projects } = this.props;
        const { itemHovered } = this.state;

        return (
            <div className={classes!.container}>
                <Responsive.Consumer steps={['Mobile']}>
                    <div className={classNames(classes!.header)}>
                        {Language === 'en' ? 'Project' : 'Projets'}
                        <Close />
                    </div>
                </Responsive.Consumer>
                <div className={classes!.containerInner}>
                    {Projects.map((project, i) => (
                        <article
                            key={i}
                            className={classes!.projectItem}>
                            <div
                                className={classes!.projectItemInner}
                                // tslint:disable-next-line:jsx-no-lambda
                                onMouseEnter={(e) => this.setState(() => ({ itemHovered: i }))}
                                onMouseLeave={this._HandleMouseLeave}
                            >
                                <div className={classes!.projectText}>
                                    <h4 className={classes!.projectTitle}>{project.Title}</h4>
                                    <h6 className={classes!.projectSubtitle}>{project.Location}</h6>
                                </div>
                                <div className={classes!.projectImage}>
                                    <div className={classes!.projectImageInner}>
                                        <figure
                                            className={classNames(
                                                classes!.figure, 
                                                (itemHovered !== i && itemHovered !== undefined) ? 
                                                    classes!.fadeOut : '')}
                                        >
                                            <Image pictureRef={project.Image} />
                                        </figure>
                                    </div>
                                </div>
                                <Link className={classes!.link} to={`/${Language}/projects/${project.UID}`} />
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        );
    }

    private _HandleMouseEnter(n: number) {
        this.setState(() => ({ itemHovered: n }))
    }

    private _HandleMouseLeave() {
        // tslint:disable-next-line:no-console
        console.log("log");
        this.setState(() => ({ itemHovered: undefined }))
    }
}

export default withStyles(styles)(ProjectList);


// WEBPACK FOOTER //
// ./src/components/ProjectList.tsx